import { Component, OnInit, ViewChild, ElementRef, HostListener, AfterViewInit, AfterViewChecked, ViewChildren, QueryList} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreatePostComponent } from 'src/app/tools/create-post/create-post.component';
import { FirebaseTSFirestore, Limit, OrderBy, Where, Cursor } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { UserData } from '../../models/user.model';
import { Story, User } from '../../models/story.model';
import { PostData, CommentData, FirestoreTimestamp } from '../../models/post.model';
import { ChatWindow } from '../../models/chat.model';

import { AppComponent } from 'src/app/app.component';
import { Subscription, Timestamp } from 'rxjs';
import { ImageCropDialogComponent } from 'src/app/image-crop-dialog/image-crop-dialog.component';

import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';
import { EditProfileDialogComponent } from 'src/app/edit-profile-dialog/edit-profile-dialog.component';
import { ChangeProfilePictureDialogComponent } from 'src/app/change-profile-picture-dialog/change-profile-picture-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChatService, Message } from 'src/app/services/chat.service';
import { FirebaseTSApp } from 'firebasets/firebasetsApp/firebaseTSApp';
import { DocumentData, getFirestore, QueryDocumentSnapshot } from 'firebase/firestore';
import { Firestore, collection, query, orderBy, limit, startAfter, getDocs, DocumentSnapshot, where } from '@firebase/firestore';
import { FirebaseApp } from '@firebase/app';
import { UserService } from 'src/app/services/user.service';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ChatContentBottomSheetComponent } from 'src/app/tools/chat-content-bottom-sheet/chat-content-bottom-sheet.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { StoryViewerComponent } from '../../tools/story-viewer/story-viewer.component';
import { CreateStoryComponent } from 'src/app/tools/create-story/create-story.component';






@Component({
  selector: 'app-feed',
  templateUrl: './feed.component.html',
  styleUrl: './feed.component.css'
})
export class FeedComponent implements OnInit, AfterViewInit, AfterViewChecked{
  @ViewChild('videoPlayer', { static: false }) videoPlayer: ElementRef<HTMLVideoElement>;
  @ViewChild('sliderContainer', { static: false }) sliderContainer: ElementRef;
  @ViewChild('loadMoreTrigger', { static: false }) loadMoreTrigger: ElementRef;
  @ViewChildren('messageContainer') messageContainers!: QueryList<ElementRef>; // Gérer plusieurs containers
  firestore = new FirebaseTSFirestore();
  firestore2: Firestore;
  auth = new FirebaseTSAuth();
  posts: PostData [] = [];
  userHasProfile = true;
  userData: any;
  username = "";
  profession = "";
  listeners: { [key: string]: () => void } = {};
  currentUser : UserData;
  coverPhotoUrl = "";
  mutualFollowers: UserData[] = [];
  users: UserData[] = [];
  users0: Array<User> = [];
  id: string;
  name: string;
  stories: Story[];
  imagePreviewUrl: string | ArrayBuffer | null = null;
  isLoading = false;
  lastLoadedPost: PostData | null = null;
  batchSize = 5;
  hasMorePosts: boolean = true;
  lastDoc: DocumentSnapshot | null = null;
  isUserAtBottom: boolean = true;
  public suggestedFriends: any[] = [];
  private userId: string;
  currentAudio: HTMLAudioElement | null = null;
  private breakpointSubscription: Subscription;
  searchTerm: string = '';
  showFileOptions = false;
  postIds = new Set<string>();

  // Variables pour gérer la lecture unique des médias
  activeVideo: HTMLVideoElement | null = null;
  activeAudio: HTMLAudioElement | null = null;

  // Getter pour profilePhotoUrl
  get profilePhotoUrl(): string {
    return this.userData?.profilePhotoUrl || "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c";
  }

 
  

 
  

  


  constructor(private dialog: MatDialog, private chatService: ChatService, private userService: UserService, private bottomSheet: MatBottomSheet, private breakpointObserver: BreakpointObserver,
    ) { 
    // Initialize Firestore
    this.firestore2 = getFirestore(); // Assurez-vous de configurer Firebase correctement
  }

  openChats: ChatWindow[] = [];

  // Méthode appelée lorsqu'une vidéo est jouée
  onVideoPlay(video: HTMLVideoElement) {
    // Si un autre média est en cours de lecture, l'arrêter
    if (this.activeAudio && !this.activeAudio.paused) {
      this.activeAudio.pause();
    }
    if (this.activeVideo && this.activeVideo !== video && !this.activeVideo.paused) {
      this.activeVideo.pause();
    }
    this.activeVideo = video;
  }

  // Méthode appelée lorsqu'un audio est joué
  onAudioPlay(audio: HTMLAudioElement) {
    // Si un autre média est en cours de lecture, l'arrêter
    if (this.activeVideo && !this.activeVideo.paused) {
      this.activeVideo.pause();
    }
    if (this.activeAudio && this.activeAudio !== audio && !this.activeAudio.paused) {
      this.activeAudio.pause();
    }
    this.activeAudio = audio;
  }

  ngOnDestroy() {
    // Arrêter tous les médias lors de la destruction du composant
    if (this.activeVideo) {
      this.activeVideo.pause();
    }
    if (this.activeAudio) {
      this.activeAudio.pause();
    }
    // ... autres nettoyages ...
  }

  ngOnInit(): void {
    
    this.getPosts();
    //alert(this.auth.getAuth().currentUser.uid);
    this.loadUserProfile();

    this.getStories();

    this.userId = this.auth.getAuth().currentUser.uid; // Récupérer l'utilisateur connecté
    this.loadSuggestedFriends();

    // Observer les changements de taille d'écran
    this.breakpointSubscription = this.breakpointObserver.observe([`(max-width: 768px)`])
      .subscribe(result => {
        if (result.matches) {
          // Logique pour ouvrir le BottomSheet en version mobile
        } else {
          // En version desktop, le BottomSheet doit se fermer
          this.bottomSheet.dismiss();
        }
      });
    
    
  }





  

  ngAfterViewChecked() {
    // Boucle pour vérifier le statut de chaque chatWindow
    this.openChats.forEach((chatWindow, index) => {
      const messageContainer = this.messageContainers.toArray()[index]?.nativeElement;
      if (chatWindow.isUserAtBottom && messageContainer) {
        this.scrollToBottom(messageContainer);
      }
    });
  }

  

  onAudioPlayed2(audio: HTMLAudioElement) {
    // Pause le fichier audio actuellement en cours de lecture (s'il y en a un)
    if (this.currentAudio && this.currentAudio !== audio) {
      this.currentAudio.pause();
    }
    // Assigne l'audio actuel à la nouvelle lecture
    this.currentAudio = audio;
  }


  toggleFileOptions() {
    this.showFileOptions = !this.showFileOptions; // Alterner l'affichage des options de fichiers
  }
  
  selectFile(chatWindow: ChatWindow, type: 'audio' | 'image') {
    const fileInput = document.createElement('input');
    
    fileInput.type = 'file';
    fileInput.accept = type === 'audio' ? 'audio/*' : 'image/*';
    
    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        if (type === 'audio') {
          chatWindow.selectedAudioFile = file;
          chatWindow.audioBlobUrl = URL.createObjectURL(file);
          console.log('Fichier audio sélectionné:', file);
        } else if (type === 'image') {
          chatWindow.selectedImageFile = file;
          chatWindow.imageBlobUrl = URL.createObjectURL(file);
          console.log('Fichier image sélectionné:', file);
        }
      }
    };
    
    fileInput.click();
  }
  




  stopRecording(chatWindow: ChatWindow) {
    if (chatWindow.currentMediaRecorder) {
      chatWindow.currentMediaRecorder.stop();
      console.log("Enregistrement audio arrêté");
    }
    chatWindow.isRecording = false; // Mettez à jour l'état ici
   
    // Si vous n'avez pas besoin de garder `selectedAudioFile`, vous pouvez aussi le réinitialiser ici.
  }

  getMessageFormattedDate(timestamp: any): string {
    const messageDate = timestamp ? new Date(timestamp) : new Date();
    const now = new Date();
  
    // Calcul de la différence en millisecondes
    const diffInMs = now.getTime() - messageDate.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60); // conversion en heures
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // conversion en jours
  
    // Si le message date d'aujourd'hui
    if (diffInHours < 24) {
      return messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
    } 
  
    // Si le message date d'hier
    else if (diffInHours >= 24 && diffInHours < 48) {
      return `Hier, ${messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false })}`;
    }
  
    // Si le message est vieux de plus de 48 heures mais dans la même année
    else if (diffInDays >= 2 && now.getFullYear() === messageDate.getFullYear()) {
      return `${messageDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })} à ${messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false })}`;
    }
  
    // Si le message date de plus d'une année
    else {
      return messageDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' }) + ' à ' +
             messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
    }
  
  }

  startRecording(chatWindow: ChatWindow) {
    chatWindow.isRecording = true;
    console.log("Enregistrement audio commencé");
  
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        const mediaRecorder = new MediaRecorder(stream);
        let audioChunks: Blob[] = [];
  
        mediaRecorder.ondataavailable = event => {
          audioChunks.push(event.data);
        };
  
        mediaRecorder.onstop = () => {
          const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
          chatWindow.audioBlobUrl = URL.createObjectURL(audioBlob);
          chatWindow.selectedAudioFile = new File([audioBlob], 'recorded-audio.wav', { type: 'audio/wav' });
          console.log('Enregistrement audio arrêté, blob créé.');
        };
  
        mediaRecorder.start();
        chatWindow.currentMediaRecorder = mediaRecorder;
      })
      .catch(error => {
        console.error("Erreur lors de l'accès au microphone:", error);
      });
  }


  
  

  

  removeFile(chatWindow: ChatWindow) {
    chatWindow.selectedAudioFile = null;
    chatWindow.selectedImageFile = null;
    chatWindow.audioBlobUrl = null;
    chatWindow.imageBlobUrl = null;
    console.log('Fichier sélectionné réinitialisé');
  }

  

  

  

  scrollToBottom(container: HTMLElement): void {
    try {
      container.scrollTop = container.scrollHeight;
    } catch (err) {
      console.error(err);
    }
  }

  onChatSelected(chatItem: any) {
    if (window.innerWidth <= 768) {
      // Ouvrir le bottomSheet avec les données du chat
      this.bottomSheet.open(ChatContentBottomSheetComponent, {
        data: chatItem  // Vous passez les données du chat sélectionné ici
      });
    }
  }

  
  checkIfScrolledToBottom(chatWindow: any, container: any): void {
    // Vérifier si l'utilisateur est proche du bas
    const isAtBottom = container.scrollHeight - container.scrollTop === container.clientHeight;

    // Mettre à jour l'état de la fenêtre de chat pour savoir si l'utilisateur est en bas ou non
    chatWindow.isUserAtBottom = isAtBottom;
  }

  // Charger la liste des amis suggérés
  loadSuggestedFriends() {
    this.userService.getSuggestedFriends(this.userId).subscribe(friends => {
      this.suggestedFriends = friends;
    });
  }

  // Suivre un utilisateur
  followUser(userId: string) {
    this.userService.followUser(this.userId, userId).then(() => {
      this.removeSuggestion(userId);
    });
  }

  // Retirer une suggestion de la liste
  removeSuggestion(userId: string) {
    this.suggestedFriends = this.suggestedFriends.filter(user => user.id !== userId);
  }

  

  loggedIn(){
    return true;
  }

  onCreatePostClick() {
    const isMobile = this.breakpointObserver.isMatched('(max-width: 480px)');
    
    if (isMobile) {
      const bottomSheetRef = this.bottomSheet.open(CreatePostComponent, {
        panelClass: 'bottom-sheet-container'
      });
      
      bottomSheetRef.instance.postCreated.subscribe(() => {
        // Réinitialiser les variables de pagination
        this.posts = [];
        this.lastDoc = null;
        this.hasMorePosts = true;
        this.postIds.clear();
        
        // Recharger les posts
        this.getPosts();
      });
    } else {
      const dialogRef = this.dialog.open(CreatePostComponent, {
        width: '600px',
        maxWidth: '100vw',
        maxHeight: '100vh',
        panelClass: 'create-post-dialog'
      });

      dialogRef.componentInstance.postCreated.subscribe(() => {
        // Réinitialiser les variables de pagination
        this.posts = [];
        this.lastDoc = null;
        this.hasMorePosts = true;
        this.postIds.clear();
        
        // Recharger les posts
        this.getPosts();
      });
    }
  }

  getPosts2(){
    this.firestore.getCollection(
      {
        path: ["Posts"],
        where: [
          new OrderBy("timestamp", "desc"),
          new Limit(30),
          
        ],
        onComplete: (result) => {
          result.docs.forEach(
            doc => {
              
              let post = <PostData>doc.data();
              post.postId = doc.id;
              if(post.type == "image" || post.type == "audio-image"){
                this.posts.push(post);
              }
              
            }
          );
        },
        onFail: err => {

        }
      }
    );
  }

  getPosts00() {
    this.isLoading = true;
    let query = {
      path: ["Posts"],
      where: [
        new OrderBy("timestamp", "desc"),
        new Limit(this.batchSize)
      ],
      onComplete: (result) => {
        const newPosts: PostData[] = [];
        result.docs.forEach(doc => {
          let post = <PostData>doc.data();
          post.postId = doc.id;
          newPosts.push(post);
        });
        
        if (newPosts.length > 0) {
          this.posts = this.posts.concat(newPosts);
          this.lastLoadedPost = newPosts[newPosts.length - 1];
        }
        this.isLoading = false;
      },
      onFail: err => {
        console.error(err);
        this.isLoading = false;
      }
    };

    if (this.lastLoadedPost) {
      query.where.push(new Where("timestamp", "<", this.lastLoadedPost.timestamp));
    }

    this.firestore.getCollection(query);
  }

  ngAfterViewInit(): void {
    this.setupIntersectionObserver();
  }

  async getPosts() {
    
    if (!this.hasMorePosts) return;

    try {
      let postsQuery = query(
        collection(this.firestore2, 'Posts'),
        orderBy('timestamp', 'desc'),
        limit(10)
      );

      if (this.lastDoc) {
        postsQuery = query(
          postsQuery,
          startAfter(this.lastDoc)
        );
        //alert("héoooiii");
      }

      // Attendre 1 seconde avant de continuer
      await new Promise(resolve => setTimeout(resolve, 300));
      
      const querySnapshot = await getDocs(postsQuery);

      if (!querySnapshot.empty) {
        this.lastDoc = querySnapshot.docs[querySnapshot.docs.length - 1];
        
        
        querySnapshot.forEach(doc => {
          const post = <PostData>doc.data();
          post.postId = doc.id;

          
          if (post.lenali && post.lenali === true && !this.postIds.has(post.postId)) {
            this.posts.push(post);
            this.postIds.add(post.postId); // Ajouter l'ID au Set
          }
          
        });

       
        if(this.posts.length <= 5){
          this.getPosts();
        }

      } else {
        
        this.hasMorePosts = false;
        
      }
    } catch (error) {
      console.error("Error fetching posts: ", error);
    }
  }



  
  
  
  
  

  setupIntersectionObserver() {
    
    const observer = new IntersectionObserver(entries => {
      
      if (entries[0].isIntersecting && this.hasMorePosts) {
        this.getPosts();
      }
    }, {
      root: null,
      rootMargin: '30px',
      threshold: 1.0
    });

    if (this.loadMoreTrigger) {
      observer.observe(this.loadMoreTrigger.nativeElement);
    }
  }



  

 

  

 

  
  /**story */

  loadUserProfile() {
    const userId = this.auth.getAuth().currentUser.uid; // Assurez-vous de récupérer l'ID utilisateur correctement
    this.firestore.getDocument({
      path: ["Users", userId],
      onComplete: result => {
        this.userData = result.data();

        // Logique pour récupérer les followers mutuels
        this.getMutualFollowers(this.auth.getAuth().currentUser.uid, this.userData.following).then(
          followers => {
          this.mutualFollowers = followers;
          }
        );

        if (!this.userData.profilePhotoUrl) {
          this.userData.profilePhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c";
        }

        if (!this.userData.coverPhotoUrl) {
          this.coverPhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf";
        } else {
          this.coverPhotoUrl = this.userData.coverPhotoUrl;
        }
        
        
      },
      onFail: err => {
        console.error(err);
      }
    });


  }

  listenToChange(){
    this.firestore.listenToDocument(
      {
        name: "Getting Document",
        path: ["Users", this.auth.getAuth().currentUser.uid],
        onUpdate: (result) => {
          this.loadUserProfile();   
        }
      }
    );
  }

  
  
  isStoryOpen = false;
  currentStoryIndex = 0;
  currentUserStories: Story[];
  currentStoryUser: User | null = null;
  isCreateStoryModalOpen = false;
  selectedImage: string | ArrayBuffer | null = null;
  selectedImageFile: File | null = null;
  selectedVideo: string | ArrayBuffer | null = null;
  storage = new FirebaseTSStorage();

  // Variables pour la gestion des stories
  storyProgress: number = 0;
  storyDuration: number = 5000; // 5 secondes par défaut
  private storyTimer: any;

  // Méthodes de gestion des stories
  openStory(user: User): void {
    // Trier les stories de l'utilisateur
    const sortedStories = [...user.stories].sort((a, b) => {
      const aTime = typeof a.timestamp === 'number' ? a.timestamp :
                   (a.timestamp?.seconds || 0) * 1000;
      const bTime = typeof b.timestamp === 'number' ? b.timestamp :
                   (b.timestamp?.seconds || 0) * 1000;
      
      // Si c'est l'utilisateur courant, trier du plus ancien au plus récent
      if (user.uid === this.auth.getAuth().currentUser?.uid) {
        return aTime - bTime;
      }
      // Pour les autres utilisateurs, trier du plus récent au plus ancien
      return bTime - aTime;
    });

    const dialogRef = this.dialog.open(StoryViewerComponent, {
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'story-viewer-dialog',
      data: {
        stories: sortedStories,
        currentUser: user
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      // Gérer la fermeture du dialogue si nécessaire
    });
  }

  getLatestStory(stories: Story[]): Story | null {
    if (!Array.isArray(stories) || stories.length === 0) {
      return null;
    }
    
    return stories.reduce((latest, current) => {
      if (!latest || !current) return latest || current;
      
      const latestTime = typeof latest.timestamp === 'number' ? latest.timestamp : 
                        (latest.timestamp?.seconds || 0) * 1000;
      const currentTime = typeof current.timestamp === 'number' ? current.timestamp :
                         (current.timestamp?.seconds || 0) * 1000;
      
      return currentTime > latestTime ? current : latest;
    });
  }

  getLatestStoryTimestamp(stories: Story[]): number {
    if (!stories || stories.length === 0) return 0;
    
    return Math.max(...stories.map(story => {
      if (typeof story.timestamp === 'number') {
        return story.timestamp;
      } else if (story.timestamp && typeof story.timestamp.seconds === 'number') {
        return story.timestamp.seconds * 1000;
      }
      return 0;
    }));
  }

  closeStory(): void {
    this.isStoryOpen = false;
    this.currentStoryUser = null;
    this.currentUserStories = [];
  }

  previousStory(): void {
    if (this.currentStoryIndex > 0) {
      this.currentStoryIndex--;
      this.startStoryTimer(); // Redémarrer le timer pour la story précédente
    }
  }

  nextStory(): void {
    if (this.currentStoryIndex < this.currentUserStories.length - 1) {
      this.currentStoryIndex++;
      this.startStoryTimer(); // Redémarrer le timer pour la nouvelle story
    } else {
      this.closeStory();
    }
  }

  onStoryEnded(): void {
    this.nextStory();
  }

  startStoryTimer(): void {
    this.stopStoryTimer();
    this.storyProgress = 0;
    
    // Définir la durée en fonction du type de média
    const currentStory = this.currentUserStories[this.currentStoryIndex];
    this.storyDuration = currentStory?.type === 'video' && currentStory.duration 
      ? currentStory.duration * 1000  // Convertir en millisecondes
      : 5000; // 5 secondes pour les images

    // Démarrer le timer
    const startTime = Date.now();
    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      this.storyProgress = (elapsed / this.storyDuration) * 100;
      
      if (this.storyProgress >= 100) {
        this.nextStory();
      } else {
        this.storyTimer = requestAnimationFrame(updateProgress);
      }
    };
    
    this.storyTimer = requestAnimationFrame(updateProgress);
  }

  stopStoryTimer(): void {
    if (this.storyTimer) {
      cancelAnimationFrame(this.storyTimer);
      this.storyTimer = null;
    }
  }

  getProgressWidth(index: number): number {
    if (index < this.currentStoryIndex) return 100;
    if (index > this.currentStoryIndex) return 0;
    return this.storyProgress;
  }

  formatStoryTimestamp(timestamp: number): string {
    if (!timestamp) return '';
    
    const date = new Date(timestamp);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    
    if (diffInSeconds < 60) return 'À l\'instant';
    if (diffInSeconds < 3600) return `Il y a ${Math.floor(diffInSeconds / 60)} min`;
    if (diffInSeconds < 86400) return `Il y a ${Math.floor(diffInSeconds / 3600)} h`;
    return `Il y a ${Math.floor(diffInSeconds / 86400)} j`;
  }

  scrollLeft(): void {
    const container = this.sliderContainer.nativeElement;
    container.scrollBy({ left: -150, behavior: 'smooth' });
    this.sliderContainer.nativeElement.scrollLeft -= 200; //
  }

  scrollRight(): void {
    const container = this.sliderContainer.nativeElement;
    container.scrollBy({ left: 150, behavior: 'smooth' });
    this.sliderContainer.nativeElement.scrollLeft += 200; 
  }

  openCreateStoryModal(): void {
    const dialogRef = this.dialog.open(CreateStoryComponent, {
      width: '500px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '90vh',
      panelClass: 'story-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getStories(); // Rafraîchir les stories après la création
    });
  }

  closeCreateStoryModal(): void {
    this.isCreateStoryModalOpen = false;
    this.selectedImage = null;
  }

  

  onFileSelected(event: any): void {
    this.selectedImageFile = event.target.files[0];
    const file = this.selectedImageFile;
    this.generateImagePreview();
    
  }

 

  generateImagePreview() {
    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreviewUrl = reader.result;
    };
    reader.readAsDataURL(this.selectedImageFile!);
  }

  createStory(type: 'image' | 'video'): void {
    if (!this.selectedImageFile) {
      console.error('No file selected');
      return;
    }

    const file = this.selectedImageFile;
    const userId = this.auth.getAuth().currentUser?.uid;
    if (!userId) {
      console.error('No user ID found');
      return;
    }

    this.storage.upload({
      uploadName: "story",
      path: ["Users", userId, "stories", `${new Date().getTime()}_${file.name}`],
      data: {
        data: file,
        metadata: {
          contentType: file.type
        }
      },
      onComplete: (downloadUrl) => {
        const story: Story = {
          url: downloadUrl,
          type: type,
          timestamp: {
            seconds: Math.floor(Date.now() / 1000),
            nanoseconds: 0
          },
          thumbnail: downloadUrl,
          userId: userId,
          duration: type === 'video' ? 0 : 5 // 5 secondes pour les images
        };

        this.firestore.create({
          path: ["Users", userId, "stories"],
          data: story,
          onComplete: () => {
            console.log('Story created successfully');
            this.closeCreateStoryModal();
            this.selectedImageFile = null;
            this.imagePreviewUrl = null;
            // Recharger les stories
            this.getStories();
          },
          onFail: (error) => {
            console.error('Error creating story:', error);
          }
        });
      },
      onFail: (error) => {
        console.error('Error uploading file:', error);
      }

      
    });
  }

  publishStory(): void {
    if (this.selectedImageFile) {
      // Déterminer le type en fonction de l'extension du fichier
      const fileName = this.selectedImageFile.name.toLowerCase();
      const type = fileName.endsWith('.mp4') || fileName.endsWith('.mov') ? 'video' : 'image';
      this.createStory(type);
    } else {
      console.error('No file selected for story');
    }
  }

  getStories() {
    // Récupérer tous les utilisateurs
    this.firestore.getCollection({
      path: ["Users"],
      where: [], // Ajouter un tableau vide pour where car c'est requis
      onComplete: async (result) => {
        // Mapper les données des utilisateurs
        const userPromises = result.docs.map(async (doc) => {
          const userData = doc.data();
          
          // Créer l'objet utilisateur de base
          const user = {
            uid: doc.id,
            publicName: userData.publicName || '',
            description: userData.description || '',
            profession: userData.profession || '',
            ville: userData.ville || '',
            profilePhotoUrl: userData.profilePhotoUrl || '',
            coverPhotoUrl: userData.coverPhotoUrl || '',
            email: userData.email || '',
            following: userData.following || [],
            followers: userData.followers || [],
            createdAt: userData.createdAt || new Date(),
            stories: [] // Initialisation du tableau de stories
          } as User;

          // Récupérer les stories de l'utilisateur
          return new Promise<User>((resolve) => {
            this.firestore.getCollection({
              path: ["Users", doc.id, "stories"],
              where: [],
              onComplete: (storiesResult) => {
                // Filtrer les stories pour ne garder que celles qui ne sont pas expirées (1 semaine)
                const now = Date.now();
                const ONE_WEEK = 7 * 24 * 60 * 60 * 1000; // 1 semaine en millisecondes
                
                user.stories = storiesResult.docs
                  .map(storyDoc => storyDoc.data() as Story)
                  .filter(story => {
                    const storyTime = typeof story.timestamp === 'number' 
                      ? story.timestamp 
                      : (story.timestamp?.seconds || 0) * 1000;
                    return (now - storyTime) < ONE_WEEK;
                  });
                resolve(user);
              },
              onFail: (error) => {
                console.error(`Error loading stories for user ${doc.id}:`, error);
                resolve(user);
              }
            });
          });
        });

        // Attendre que toutes les promesses soient résolues
        const users = await Promise.all(userPromises);
        
        // Filtrer pour ne garder que les utilisateurs qui ont des stories actives
        this.users0 = users.filter(user => user.stories && user.stories.length > 0);
        
        // Trier les utilisateurs par timestamp de leur story la plus récente
        this.users0.sort((a, b) => {
          const latestA = this.getLatestStoryTimestamp(a.stories);
          const latestB = this.getLatestStoryTimestamp(b.stories);
          return latestB - latestA;
        });
      },
      onFail: (error) => {
        console.error('Error loading users:', error);
      }
    });
  }

  // Ouvrir le chat dans un bottom sheet (pour mobile)
  openChatBottomSheet(user: UserData): void {
    console.log('Opening chat bottom sheet for user:', user);
    this.bottomSheet.open(ChatContentBottomSheetComponent, {
      data: { user: user },
      panelClass: 'bottom-sheet-container'
    });
  }

  // Ouvrir une fenêtre de chat
  openChatWindow(user: UserData): void {
    console.log(user);
    // Vérifier si la fenêtre de chat est déjà ouverte
    const chatAlreadyOpen = this.openChats.some(chat =>  chat.userData.uid === user.uid);
    
    
    //alert("Bonjour");
    if (!chatAlreadyOpen) {

      const newChatWindow: ChatWindow = {
        userData: user,       // Utilisez l'objet `UserData` pour la propriété `userData`
        newMessage: '',       // Initialise `newMessage` à une chaîne vide
        messages: [],
        isUserAtBottom: true,         // Initialise `messages` à un tableau vide
        isRecording: false,
        audioBlobUrl: null,
        currentMediaRecorder: null,
        selectedAudioFile: null,
        selectedImageFile: null,
        imageBlobUrl: null
      };

      this.openChats.push(newChatWindow); // Ajouter l'utilisateur à la liste des chats ouverts

      const listenerName = `GetChatMessages_${this.auth.getAuth().currentUser.uid}_${user.uid}`;
      
     
       // Récupérer les messages pour ce chat
      const currentUserId = this.auth.getAuth().currentUser.uid;  // Remplacer par l'ID réel de l'utilisateur connecté
    this.chatService.getMessages2(currentUserId, user.uid, listenerName)
      .then(messages => {
        const chatUser = this.openChats.find(openChat => openChat.userData.uid === user.uid);
       
        if (chatUser) {
          chatUser.messages = messages;
        } // Stocker les messages dans l'objet utilisateur
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des messages:', error);
      });
    }
  }

  // Méthode appelée lorsque l'utilisateur veut envoyer un message à l'utilisateur d'une publication
  onMessageUser(user: UserData) {
    // Vérifier si le chat est déjà ouvert
    const existingChat = this.openChats.find(chat => chat.userData.uid === user.uid);
    if (existingChat) {
      return; // Si le chat est déjà ouvert, ne rien faire
    }

    // Créer une nouvelle fenêtre de chat
    const newChatWindow: ChatWindow = {
      userData: user,
      newMessage: '',
      messages: [],         // Initialise `messages` à un tableau vide
      isUserAtBottom: true,
      isRecording: false,
      audioBlobUrl: null,
      currentMediaRecorder: null,
      selectedAudioFile: null,
      selectedImageFile: null,
      imageBlobUrl: null
    };

    this.openChats.push(newChatWindow); // Ajouter l'utilisateur à la liste des chats ouverts
  }

  // Fermer une fenêtre de chat
  closeChatWindow(user: UserData): void {
    const listenerName = `GetChatMessages_${this.auth.getAuth().currentUser.uid}_${user.uid}`;
    this.chatService.closeChatWindow2(user.uid, listenerName);
    this.openChats = this.openChats.filter(chat => chat.userData.uid !== user.uid);
  } 

    /*sendMessage(chatWindow: ChatWindow, index: number){  
      const currentUserId = this.auth.getAuth().currentUser.uid;  // Remplacez par l'ID réel de l'utilisateur connecté
      //const chatId = this.chatService.getChatId(currentUserId, chatWindow.userData.uid);

      if (chatWindow.newMessage && chatWindow.newMessage.trim() !== '') {
        

      this.chatService.sendMessage(currentUserId,  chatWindow.userData.uid, chatWindow.newMessage.trim()).then(() => {
        // Réinitialiser la valeur de newMessage après envoi
        //newMessage = '';
        //this.userData.newMessage = '';
       
        chatWindow.newMessage = '';

        // Scroll automatique vers le bas après l'envoi d'un message

        // Scroll automatique vers le bas après l'envoi d'un message
      const messageContainer = this.messageContainers.toArray()[index]?.nativeElement;
      this.scrollToBottom(messageContainer);
      chatWindow.isUserAtBottom = true;
     
        
      })
      .catch(error => {
        console.error('Erreur lors de l\'envoi du message:', error);
      });;
      }
    }
 */
    

    sendMessage(chatWindow: ChatWindow, index: number) {
      const currentUserId = this.auth.getAuth().currentUser.uid;
    
      // Vérifiez si un fichier audio ou image est sélectionné
      if (chatWindow.selectedAudioFile || chatWindow.selectedImageFile) {
        const fileToSend = chatWindow.selectedAudioFile || chatWindow.selectedImageFile;
    
        // Si un fichier est sélectionné, utilisez sendFile
        this.chatService.sendFile(currentUserId, chatWindow.userData.uid, fileToSend).then(() => {
          this.removeFile(chatWindow); // Réinitialisez le fichier après l'envoi
          this.scrollToBottom(this.messageContainers.toArray()[index]?.nativeElement);
          chatWindow.isUserAtBottom = true;
        }).catch(error => {
          console.error("Erreur lors de l'envoi du fichier :", error);
        });
      } else if (chatWindow.newMessage && chatWindow.newMessage.trim() !== '') {
        // Si aucun fichier n'est sélectionné, utilisez sendMessage
        
        this.chatService.sendMessage(currentUserId, chatWindow.userData.uid, chatWindow.newMessage.trim()).then(() => {
          chatWindow.newMessage = '';
          this.scrollToBottom(this.messageContainers.toArray()[index]?.nativeElement);
          chatWindow.isUserAtBottom = true;
        }).catch(error => {
          console.error("Erreur lors de l'envoi du message :", error);
        });
      }
    }
    

    

    handleSend(chatWindow: ChatWindow, index: number) {
      if (chatWindow.isRecording) {
        // Si l'enregistrement est actif, on arrête l'enregistrement
        this.stopRecording(chatWindow);
      } else {
        if (chatWindow.selectedAudioFile) {
          // Si un fichier audio est sélectionné, l'envoyer
          this.sendAudio(chatWindow.selectedAudioFile, chatWindow, index);
        } else if (chatWindow.newMessage && chatWindow.newMessage.trim() !== '') {
          // Si un message est présent, l'envoyer
          this.sendMessage(chatWindow, index);
        } else {
          // Si aucun message n'est présent, commencer l'enregistrement
          this.startRecording(chatWindow);
        }
      }
    }

    sendAudio(file: File, chatWindow: ChatWindow, index: number) {
      // Implémentez votre logique pour envoyer le fichier audio
      console.log('Envoi de l\'audio:', file);
      // Vous pouvez appeler un service pour stocker le fichier audio sur Firestore ou Firebase Storage
      this.chatService.sendAudio(file, chatWindow.userData.uid).then(() => {
        // Réinitialiser l'état après l'envoi
        chatWindow.selectedAudioFile = null;
        chatWindow.audioBlobUrl = null;
      }).catch(error => {
        console.error('Erreur lors de l\'envoi de l\'audio:', error);
      });
    }

    
    

    handleKeydown(event: KeyboardEvent , chatWindow: ChatWindow, index: number) {
      if (event.key === 'Enter') {
        if (event.shiftKey) {
          // Shift + Enter: Nouvelle ligne
          const textarea = event.target as HTMLTextAreaElement;
          const cursorPosition = textarea.selectionStart;
          chatWindow.newMessage = chatWindow.newMessage.substring(0, cursorPosition) + '\n' + chatWindow.newMessage.substring(cursorPosition);
          event.preventDefault(); // Empêche l'action par défaut de l'Enter
        } else {
          // Simple Enter: Envoyer le message
          this.sendMessage(chatWindow, index);
          event.preventDefault(); // Empêche l'action par défaut de l'Enter
        }
      }
    }

    // Récupérer les followers mutuels
    async getMutualFollowers(currentUserId: string, following: string[]): Promise<UserData[]> {
      return new Promise((resolve) => {
        const uniqueUserIds = new Set<string>();
        const filteredFollowers: UserData[] = [];

        this.firestore.getCollection({
          path: ["Users"],
          where: [],
          onComplete: (result) => {
            result.docs.forEach(doc => {
              const userData = doc.data() as UserData;
              userData.uid = doc.id;

              // Vérifier si l'utilisateur est dans la liste des following
              // et n'est pas l'utilisateur actuel et n'est pas déjà dans la liste
              if (following.includes(doc.id) && 
                  doc.id !== currentUserId && 
                  !uniqueUserIds.has(doc.id)) {
                uniqueUserIds.add(doc.id);
                filteredFollowers.push(userData);
              }
            });

            resolve(filteredFollowers);
          }
        });
      });
    }
  isHovered = false;
}